var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p404"},[_c('div',{staticClass:"num"},[_vm._v(" 404 ")]),_c('div',{staticClass:"text"},[_vm._v(" Nous n'avons pas pu trouver cette page. "),_c('br'),_vm._v(" "),_c('router-link',{staticClass:"link",attrs:{"to":{ path: '/' }}},[_vm._v(" Retourner sur le site ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }